import { useEffect } from 'react';
import { useMapEvents, useMap } from 'react-leaflet';

/**
 * Composant pour gérer les clics sur la carte
 */
export function MapClickHandler({ onPointAdd }) {
    useMapEvents({
        click: (e) => {
            onPointAdd([e.latlng.lat, e.latlng.lng]);
        },
    });
    return null;
}

/**
 * Composant pour contrôler la vue de la carte
 */
export function MapViewController({ viewKey }) {
    const map = useMap();

    useEffect(() => {
        if (viewKey && viewKey.type === 'bounds' && viewKey.bounds) {
            map.flyToBounds(viewKey.bounds, {
                padding: [80, 80],
                duration: 1.5,
                maxZoom: 15,
            });
        } else if (viewKey && viewKey.type === 'center' && viewKey.center) {
            map.flyTo(viewKey.center, viewKey.zoom || 14, { duration: 1.5 });
        }
    }, [viewKey, map]);

    return null;
}